module.exports = __webpack_public_path__ + "assets/img/zxk.3c15ba68.jpg";